// baseAggregateStore.js

import {defineStore} from 'pinia'
import Vue from 'vue'

import {webSocket} from "@/store/CommonStore/webSocket";
import {useTableStore} from "@/components/Common/CommonTable";
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useConfirmStore} from "@/components/Common/CommonConfirmDialog";
import {useActionStore} from "@/components/Common/CommonBtnActionGroup";
import {getActivePinia} from "pinia"

export const useBaseAggregateStore = function (storeName = 'aggregate_main', wsUrl = '/ws/dto_core/') {
    return defineStore(storeName, {
        state: () => ({
            wsUrl: wsUrl,
            wsConnect: null,
            uid_list: [],
            uid_dict: {},
            rootData: {},
            subscriptionRootDataFlag: true,
            source_uid_task: {},
            validateUidItem: null,
            dtoModelForValidate: null,
            dtoValidateCommand: null,
            timeoutId: null,
            needValidateUid: {},
            actionsUid: {},
            actionsCallReceive: {},
        }),
        actions: {
            async fetchQueryValidate() {
                if (Object.keys(this.needValidateUid).length === 0)
                    return
                // console.log('fetchQueryValidate', this.needValidateUid, uid_set, [...uid_set])
                await this.fetchValidate()
            },

            async onChangeWatch(uid) {
                // console.log('Proxy onChange', this.rootData, target, target.uid, key, value)
                clearTimeout(this.timeoutId)
                this.needValidateUid[uid] = this.rootData[uid]
                this.timeoutId = setTimeout(this.fetchQueryValidate, 1000)
            },
            watchRootData(newValue,) {
                if (this.subscriptionRootDataFlag === true) {
                    // console.log('subscriptions setup', this.subscriptionRootDataFlag)
                    // console.time('watch App rootData')
                    for (const key of Object.keys(newValue)) {
                        // console.log('subscriptions setup', key, newValue[key], oldValue[key])
                        if (!!this.rootData && !!this.uid_dict &&
                            JSON.stringify(this.rootData[key]) !== JSON.stringify(this.uid_dict[key])) {
                            // console.log('subscriptions setup dif', key, this.rootData[key], this.uid_dict[key])
                            this.onChangeWatch(key);
                        }
                    }
                    // console.timeEnd('watch App rootData')
                }
            },

            delay(time) {
                return new Promise(resolve => setTimeout(resolve, time));
            },

            async openWebSocket() {
                if (this.wsConnect == null) {
                    console.log('openWebSocket to ' + this.wsUrl)
                    this.wsConnect = new webSocket(this.wsUrl + this.aggregateName + '/',
                        this.updateMessage, 5000)
                    this.wsConnect.connectSocket()
                }
                while (this.wsConnect.connection.readyState !== WebSocket.OPEN) {
                    await this.delay(100)
                }
            },

            async fetchItem({storeName, dtoDetailQuery, uidItem, metadata = null, callBack = null, parentUid = null}) {
                console.log('fetchItem', dtoDetailQuery, uidItem, this.aggregateName)
                if (uidItem in this.uid_dict) {
                    this.uid_dict[uidItem]['loading'] = true
                    console.log('fetchItem exist', uidItem)
                } else {
                    this.uid_dict[uidItem] = {loading: true}
                    console.log('fetchItem not exist', uidItem)
                }
                await this.openWebSocket()
                let request = {
                    aggregate_name: this.aggregateName,
                    dto_model: dtoDetailQuery,
                    store_name: storeName,
                    metadata: metadata,
                    dto: {
                        uid: uidItem,
                        parent_uid: parentUid,
                    },
                }
                this.wsConnect.connection.send(JSON.stringify(request))
                // console.log('fetchItem', this.wsUrl, request, this.uid_dict)
                if (callBack != null) callBack()
            },

            async fetchSave({storeName, dtoSaveCommand, uidItem, callBack = null}) {
                if (uidItem in this.uid_dict) {
                    this.uid_dict[uidItem]['loading'] = true
                    console.log('fetchSave exist', uidItem, this.uid_dict, this.aggregateName)
                } else {
                    this.uid_dict[uidItem] = {loading: true}
                    console.log('fetchSave not exist', uidItem, this.uid_dict, this.aggregateName)
                }
                await this.openWebSocket()
                let request = {
                    aggregate_name: this.aggregateName,
                    dto_model: dtoSaveCommand,
                    store_name: storeName,
                    dto: {
                        uid: uidItem,
                    },
                }
                this.wsConnect.connection.send(JSON.stringify(request))
                console.log('fetchSave', this.wsUrl, request, this.uid_dict)
                if (callBack != null) callBack()
            },

            async fetchValidate() {
                let uid_dict = structuredClone(this.needValidateUid)
                this.needValidateUid = {}
                await this.openWebSocket()
                let request = {
                    aggregate_name: this.aggregateName,
                    dto_model: this.dtoValidateCommand,
                    dto: {
                        uid: this.validateUidItem,
                        validate_dto_model: this.dtoModelForValidate,
                        uid_dict: uid_dict,
                        parent_uid: null,
                        create: false,
                    },
                }
                this.wsConnect.connection.send(JSON.stringify(request))
                console.log('fetchValidate', this.wsUrl, request)
            },

            async fetchList({
                                storeName, dtoListQuery,
                                search = null, quick_search = null, quick_search_flag = true, filters = {}, options = {}, query_filters = null,
                                selectedStatuses = [], selectedFilters = [], selectedSwitches = {},
                                callBack = null
                            }) {
                // console.log('fetchList', this.aggregateName)
                await this.openWebSocket()
                let request = {
                    aggregate_name: this.aggregateName,
                    dto_model: dtoListQuery,
                    store_name: storeName,
                    dto: {
                        search_term: search,
                        quick_search_term: quick_search,
                        quick_search_flag: quick_search_flag,
                        filters: filters,
                        query_filters: query_filters,
                        selected_statuses: selectedStatuses,
                        selected_filters: selectedFilters,
                        selected_switches: selectedSwitches,
                        options: options,
                    },
                }
                this.wsConnect.connection.send(JSON.stringify(request))
                console.log('fetchList', this.wsUrl, request)
                if (callBack != null) callBack()
            },

            async fetchAction({
                                  storeName, dtoActionCommand, uidItem, uidSelected, actionName,
                                  data = null, callBack = null, actionUid = null, callReceive = null
                              }) {
                console.log('fetchAction', dtoActionCommand, uidItem, uidSelected, actionName, this.aggregateName)
                await this.openWebSocket()
                let request = {
                    aggregate_name: this.aggregateName,
                    dto_model: dtoActionCommand,
                    store_name: storeName,
                    dto: {
                        uid: uidItem,
                        selected_uid_list: uidSelected,
                        action_name: actionName,
                        action_uid: actionUid,
                        data: data,
                    },
                }
                if (!!actionUid && !!callReceive) {
                    let state = useActionStore()()
                    state.actionsCallReceive[actionUid] = callReceive
                }
                this.wsConnect.connection.send(JSON.stringify(request))
                console.log('fetchAction', this.wsUrl, request, this.uid_dict)
                if (callBack != null) callBack()
            },

            async updateMessage(data) {
                // console.log('fetchMessage ', this.wsUrl, data)
                if (data.command === 'detail') this.updateDetail(data)
                if (data.command === 'list') this.updateList(data)
                if (data.command === 'validate') this.updateValidate(data)
                if (data.command === 'save') this.updateSave(data)
                if (data.command === 'action') this.updateAction(data)
                if (data.command === 'action_state') this.updateActionState(data)
                if (data.command === 'action_force') this.updateActionForce(data)
                if (data.command === 'task') this.updateTaskState(data)
                if (data.command === 'task_list') this.updateTaskListState(data)
                if (data.command === 'confirm') this.updateConfirm(data)
                if (data.command === 'download') this.updateDownload(data)
            },

            updateDetail(data) {
                console.log("data.command === 'detail' and match", data)
                let storeDetail = useDetailStore(data.store_name)()
                this.subscriptionRootDataFlag = false
                this.$patch((state) => {
                    for (let [key, value] of Object.entries(data.uid_dict)) {
                        value['loading'] = false
                        Vue.set(state.uid_dict, key, structuredClone(value))
                        Vue.set(state.rootData, key, structuredClone(value))
                    }
                })
                this.subscriptionRootDataFlag = true
                storeDetail.common = data.common
                storeDetail.topToolbar = data.top_toolbar
                storeDetail.bottomToolbar = data.bottom_toolbar
                storeDetail.callReceive()
            },

            updateValidate(data) {
                console.log("data.command === 'validate' and match", data, this.needValidateUid)
                this.subscriptionRootDataFlag = false
                this.$patch((state) => {
                    for (let [key, value] of Object.entries(data.uid_dict)) {
                        // if (this.needValidateUid[key] !== undefined)
                            // console.log('Uid is in queue', key)
                        if ((value.version < 100000 || state.uid_dict[key] === undefined ||
                                value.version >= state.uid_dict[key].version || value.is_saved === false) &&
                            this.needValidateUid[key] === undefined) {
                            // console.log("updateValidate", value)
                            value['loading'] = false
                            Vue.set(state.uid_dict, key, structuredClone(value))
                            Vue.set(state.rootData, key, structuredClone(value))
                        } else
                            console.log(`Uid: ${key} was not updated`)
                    }
                })
                this.subscriptionRootDataFlag = true
            },

            updateList(data) {
                if (!!data.store_name) {
                    console.log("data.command === 'list'", data, data.store_name, this.aggregateName, this.$id)
                    let storeTable = useTableStore(data.store_name, this.aggregateName)()
                    this.subscriptionRootDataFlag = false
                    this.$patch((state) => {
                        for (let [key, value] of Object.entries(data.uid_dict)) {
                            value['loading'] = false
                            Vue.set(state.uid_dict, key, structuredClone(value))
                            Vue.set(state.rootData, key, structuredClone(value))
                        }
                    })
                    this.subscriptionRootDataFlag = true
                    storeTable.uidList = data.uid_list
                    storeTable.common = data.common
                    storeTable.topToolbar = data.top_toolbar
                    storeTable.bottomToolbar = data.bottom_toolbar
                    storeTable.serverItemsLength = data.server_items_length
                    storeTable.callReceive()
                }
            },

            updateSave(data) {
                console.log("data.command === 'save' and match", data)
                let storeDetail = useDetailStore(data.store_name)()
                if (data.uid in this.uid_dict) {
                    this.subscriptionRootDataFlag = false
                    this.$patch((state) => {
                        Vue.set(state.uid_dict[data.uid], 'loading', false)
                        Vue.set(state.rootData[data.uid], 'loading', false)
                    })
                    this.subscriptionRootDataFlag = true
                }
                storeDetail.callReceive()
            },

            updateAction(data) {
                console.log("data.command === 'action' and match", data)
                let storeDetail = useDetailStore(data.store_name)()
                if (data.uid in this.uid_dict) {
                    this.subscriptionRootDataFlag = false
                    this.$patch((state) => {
                        Vue.set(state.uid_dict[data.uid], 'loading', false)
                        Vue.set(state.rootData[data.uid], 'loading', false)
                    })
                    this.subscriptionRootDataFlag = true
                }
                storeDetail.callReceive()
            },

            updateActionState(data) {
                let state = useActionStore()()
                console.log("data.command === 'action_state'", data, state)
                let actionsUid = structuredClone(state.actionsUid)
                actionsUid[data.action_uid] = data.action_state
                state.actionsUid = structuredClone(actionsUid)
                let callReceive = state.actionsCallReceive[data.action_uid]
                if (!!callReceive) {
                    delete state.actionsCallReceive[data.action_uid]
                    callReceive(data)
                }
            },

            updateActionForce(data) {
                console.log("data.command === 'action_force'", data, getActivePinia())
                for (const store of getActivePinia()._s) {
                    if (data.action === 'refresh' &&
                        (store[1]['dtoListQuery'] === data.dto_query ||
                            store[1]['dtoDetailQuery'] === data.dto_query)) {
                        store[1].update()
                        return
                    }
                }
            },

            updateTaskState(data) {
                console.log("data.command === 'task'", data)
                let source_uid_task = structuredClone(this.source_uid_task)
                source_uid_task[data.task_dto.source_uid] = data.task_dto
                this.source_uid_task = source_uid_task
            },

            updateTaskListState(data) {
                console.log("data.command === 'task_list'", data)
                let source_uid_task = structuredClone(this.source_uid_task)
                for (let item of data.task_list_response_dto) {
                    // console.log("task", item.task_dto)
                    source_uid_task[item.task_dto.source_uid] = item.task_dto
                }
                this.source_uid_task = source_uid_task
            },

            updateConfirm(data) {
                console.log("data.command === 'confirm'", data)
                let state = useConfirmStore(data.store_name)()
                state.dialog = data.dialog
                state.message = data.message
                state.action_list = data.action_list
                state.input_list = data.input_list
                state.dto_action_command = data.dto_action_command
                state.current_uid = data.current_uid
                state.selected_uid_list = data.selected_uid_list
                state.request = data.request
                state.type = data.type
                state.timeout = data.timeout
                state.callReceive()
            },

            updateDownload(data) {
                console.log("data.command === 'download'", data)
                let blob_data = null
                if (data.file_type === 'application/ms-excel')
                    blob_data = s2ab(atob(data.file_data))
                else
                    blob_data = data.file_data
                let blob = new Blob([blob_data], {type: data.file_type})
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = data.file_name;
                link.click();
            },

            getProxyList(uidList) {
                let result = []
                if (!!this.rootData)
                    uidList.forEach(uid => result.push(this.rootData[uid]))
                return result
            },

        },
        getters: {
            // aggregateName: (state) => 'aggregate_main',
            aggregateName: (state) => state.$id,
        },
    })
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export const useAggregateStore = useBaseAggregateStore()

